import React from 'react'

export function sugerenciaNumeroIncorrecto () {
  return (
    <div className='toast-sugerencia-texto'>
      <p>Número de CTG incorrecto</p>
      <p>Este error puede surgir por diferentes motivos: </p>
      <b>
        <p>- El QR de la carta de porte no se encuentra en buen estado, puede probrar ingresarla desde cabina</p>
        <p>- La carta de porte no existe en el sistema de Terminal Quequén (es de otro elevador).</p>
      </b>
    </div>
  )
}

export const erroresPesado = {
  'Número de CTG incorrecto, por favor verifique que se esté leyendo la carta de porte que corresponde': sugerenciaNumeroIncorrecto()
}
